import { render, staticRenderFns } from "./AddOrEditAuthority.vue?vue&type=template&id=1786f44f&scoped=true"
import script from "./AddOrEditAuthority.vue?vue&type=script&lang=js"
export * from "./AddOrEditAuthority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1786f44f",
  null
  
)

export default component.exports